var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { attrs: { type: "card" } },
    [
      _c("template", { slot: "header" }, [_vm._v("导出文本")]),
      _c("el-input", {
        attrs: {
          type: "textarea",
          autosize: { minRows: 2, maxRows: 4 },
          placeholder: "请输入内容 然后点击保存按钮导出文本文档"
        },
        model: {
          value: _vm.text,
          callback: function($$v) {
            _vm.text = $$v
          },
          expression: "text"
        }
      }),
      _c(
        "div",
        { staticClass: "d2-mt" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.exportTxt } },
            [
              _c("d2-icon", { attrs: { name: "download" } }),
              _vm._v(" 保存为 txt ")
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }